export default "__VITE_ASSET__DmGKnYKQ__"